import { REPORT_REASONS } from '../domain/enums';
import { ERROR_CODES } from '../errors/error-codes';
/**
 * BİLDİRME YÜZEYİNİN METİN KARARLARI — web + mobil TEK kaynak (Blok 19 Y2).
 *
 * `POST /reports` Faz 1'den beri canlıydı ama hiçbir uygulamada kullanıcı
 * yüzeyi yoktu. Yüzey iki uygulamada birden açıldığı için sebep listesi ve
 * hata eşlemesi burada durur — iki ekran aynı cümleyi basar.
 */
/** Sebep listesi sözleşmeden ENUMERE edilir; ekran kendi listesini yazmaz. */
export const REPORT_REASON_OPTIONS = REPORT_REASONS;
export function reportReasonLabelKey(reason) {
    return `report.reasons.${reason}`;
}
const KNOWN_ERROR_CODES = new Set(Object.values(ERROR_CODES));
/**
 * Bildirme hatasının metin anahtarı. Diyalog başarı olmadan kapanmaz, o yüzden
 * hata da yazılmak ZORUNDA (Blok 8 dersi). Bilinmeyen kod ham gösterilmez.
 */
export function reportErrorKey(code, statusCode) {
    if (!code)
        return null;
    if (statusCode === 0)
        return 'meetings.errorOffline';
    if (!KNOWN_ERROR_CODES.has(code))
        return `errors.${ERROR_CODES.INTERNAL_ERROR}`;
    return `errors.${code}`;
}
//# sourceMappingURL=report-text.js.map